import { FaInbox } from "react-icons/fa";
import styled from "styled-components";

const EmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 500px;
  width: 100%;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 40px 20px;
  margin: 20px 0;
`;

const EmptyStateContent = styled.div`
  text-align: center;
  max-width: 500px;
`;

const IconWrapper = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
  
  svg {
    width: 120px;
    height: 120px;
    color: #e0e7ff;
    stroke-width: 1.5;
  }
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
`;

const Description = styled.p`
  font-size: 15px;
  color: #6b7280;
  margin-bottom: 32px;
  line-height: 1.6;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
`;

const PrimaryButton = styled.button`
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 12px 28px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  
  &:hover {
    background-color: #1d4ed8;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

const SecondaryButton = styled.button`
  background-color: transparent;
  color: #2563eb;
  border: 1px solid #e5e7eb;
  padding: 12px 28px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  
  &:hover {
    background-color: #f3f4f6;
    border-color: #d1d5db;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export default function EmptyState({heading, description, onCreate, onView}) {
  return (
    <EmptyStateContainer>
      <EmptyStateContent>
        <IconWrapper>
          <FaInbox />
        </IconWrapper>
        <Title>{heading}</Title>
        <Description>
          {description  }
        </Description>
        <ButtonGroup>
          {onCreate && <PrimaryButton onClick={onCreate}>
            Create Task
          </PrimaryButton>}
          {onView && <SecondaryButton onClick={() => alert('View all tasks')}>
            View All Tasks
          </SecondaryButton>}
        </ButtonGroup>
      </EmptyStateContent>
    </EmptyStateContainer>
  );
}